import each from 'lodash/each';

export class PrinterGroup {
  private _name: string;
  private _id: string;

  // all the child printer IDS
  private _printerAddresses: string[] = [];

  constructor(groupObj: any) {
    this._name = groupObj.name;
    this._id = groupObj.id;
  }

  linkPrintersByAddress(printerAddresses: string[]) {
    each(printerAddresses, (address: string) => {
      if (this._printerAddresses.indexOf(address) == -1) {
        this._printerAddresses.push(address);
      }
    });
  }

  unlinkPrintersByAddress(printerAddresses: string[]) {
    each(printerAddresses, (address: string) => {
      const index: number = this._printerAddresses.indexOf(address);
      if (index > -1) {
        this._printerAddresses.splice(index, 1);
      }
    });
  }

  export(): any {
    return {
      name: this._name,
      id: this._id,
      printers: this._printerAddresses,
    };
  }

  public get ID(): string {
    return this._id;
  }

  public get Name(): string {
    return this._name;
  }

  public get Linked_printers(): string[] {
    return this._printerAddresses;
  }
}
